import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { MessageService } from '../services/login.service';
import { KapraoService } from '../services/kaprao.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  subscription: Subscription;
  isLogin = false;
  userProfile;
  title = 'kaprao';
  isPrint = false;
  constructor(
    private messageService: MessageService,
    private service: KapraoService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'lock',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/lock.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'eye-open',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/eye-open.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'eye-close',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/eye-close.svg'
      )
    );
    this.subscription = this.messageService
      .getMessage()
      .subscribe((message) => {
        console.log(message);
        // localStorage.getItem("token") ||
        if (message.text == 'login' || message.text == 'update') {
          this.isLogin = true;
          this.getProfile();
        } else if (message.text == 'logout') {
          console.log('aaa');
          // clear messages when empty message received
          this.userProfile = null;
          this.isLogin = false;
        }
        if (message.text == 'print') {
          this.isPrint = true;
        }
      });
    if (localStorage.getItem('token')) {
      setTimeout(() => {
        this.isLogin = true;
        console.log('dsada');
      }, 0);
      this.service.getProfile().then((res: any) => {
        // console.log(res.data);
        this.userProfile = (({ username, position, permission }) => ({
          permission,
          username,
          position,
        }))(res.data);
      });
    }
  }
  getProfile() {
    this.service.getProfile().then((res: any) => {
      // console.log(res.data);
      this.userProfile = (({ username, position, permission }) => ({
        permission,
        username,
        position,
      }))(res.data);
    });
  }
}
